import React, { Component } from 'react';
import ReactEcharts from 'echarts-for-react';
import ColorPicker from 'src/components/Colorpicker/index-beta';
import { toast } from 'react-toastify';
import { useChartManagement } from 'src/managers/chartManager/stateManagement/management';

export default class SingleStackChart extends Component {
  constructor(props) {
    super(props);
    const { error } = this.props;

    this.chartRef = React.createRef();
    this.updateOptions = this.updateOptions.bind(this);

    this.configurationError = error;
    this.colorPickerRef = React.createRef();
    this.manager = useChartManagement(this);
  }

  shouldComponentUpdate(nextProps) {
    return this.manager.changesChecker(nextProps);
  }

  componentDidUpdate() {
    const { onUpdateScrollView } = this.props;

    if (onUpdateScrollView) {
      onUpdateScrollView();
    }
  }

  onChartReady(echarts) {
    this.echarts = echarts;
  }

  /**
   * atualiza as configuracoes da instancia de echarts
   * passada.
   */
  updateOptions(newOptions) {
    this.setState((prevState) => ({
      ...prevState,
      options: {
        ...prevState.options,
        ...newOptions,
      },
    }));
  }

  // Caso a api retorne um erro no fetch das configurações de cores, não será possivel abrir
  // o color picker e uma mensagem de erro será apresentada ao usuário.
  onConfigurationError() {
    toast.error(this.configurationError.toString());
  }

  render() {
    const {
      colorPickerColors,
      data,
      theme,
      chartRef,
    } = this.props;

    return (
      <>
        <ReactEcharts
          ref={(echarts) => {
            if (echarts && !chartRef.current.includes(echarts)) {
              chartRef.current.push(echarts);
            };
          }}
          notMerge
          option={this.manager.getOptions()}
          onChartReady={(chart) => this.onChartReady(chart)}
          onEvents={{
            legendselectchanged: (ctx) => this.manager.handleOnLegendChange(ctx),
            dblclick: ((ctx) => this.manager.handleOnDoubleClick(ctx)),
          }}
        />
        <ColorPicker
          ref={this.colorPickerRef}
          hideColorPicker={() => this.manager.colorPickerHandler.hideColorPicker()}
          changeBarColor={(newColor) => this.manager.colorPickerHandler.changeColorHandler(newColor)}
          colors={colorPickerColors}
        />
        <center>
          <h2 style={{ color: theme.title }}>
            {data.pergunta_principal.pergunta_cruzada.enunciado}
          </h2>
        </center>
      </>
    );
  }
}
